"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRODUCT_CATEGORY_RELATIONS = void 0;
var ProductCategoryRelationships = require("./product-category-relationships.json");
exports.PRODUCT_CATEGORY_RELATIONS = ProductCategoryRelationships.relationships;
